import React from 'react';
import TextInputField from '../inputs/TextInputField';
import NearbyLocation from './NearbyLocation';
import { commonFieldConfig, commonFieldTypes } from '../inputs/field.config';
import FieldTypeSelector from '../inputs/Index';
import AddMoreButton from '../inputs/AddMoreButton';
import { generateImagePath } from '../../../../helpers/helpers';

export default function LocationSection({
  investmentData,
  handleInputChange,
  handleAddItem,
  dispatch,
  removeItemFromArray,
  handleNearbyLocations,
}) {
  // Select nearbyLocations for English
  const nearbyLocationsEn = investmentData.en.locationSection.nearbyLocations;
  // Select nearbyLocations for Arabic
  const nearbyLocationsAr = investmentData.ar.locationSection.nearbyLocations;

  // English Location Fields
  const locationLinkFieldEn = [
    {
      label: 'Location Latitude',
      value: investmentData.en.locationSection.locationLat,
      section: 'locationSection',
      field: 'locationLat',
      isSameValue: true,
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
    {
      label: 'Location Longitude',
      value: investmentData.en.locationSection.locationLong,
      section: 'locationSection',
      field: 'locationLong',
      isSameValue: true,
      config: { ...commonFieldConfig['en'][commonFieldTypes.text] },
    },
  ];

  // Arabic Location Fields
  // const locationLinkFieldAr = [
  //   {
  //     label: 'خط العرض للموقع',
  //     value: investmentData.ar.locationSection.locationLat,
  //     section: 'locationSection',
  //     field: 'locationLat',
  //   },
  //   {
  //     label: 'خط الطول للموقع',
  //     value: investmentData.ar.locationSection.locationLong,
  //     section: 'locationSection',
  //     field: 'locationLong',
  //   },
  // ];

  // English Location Paragraphs
  const locationparagraphsFieldsEn =
    investmentData.en.locationSection.paragraphs.map((paragraph, index) => ({
      label: `Paragraph ${index + 1}`,
      value: paragraph,
      section: 'locationSection',
      field: 'paragraphs',
      index,
      config: { ...commonFieldConfig['en'][commonFieldTypes.textarea] },
    }));

  // Arabic Location Paragraphs
  const locationparagraphsFieldsAr =
    investmentData.ar.locationSection.paragraphs.map((paragraph, index) => ({
      label: `الفقرة ${index + 1}`,
      value: paragraph,
      section: 'locationSection',
      field: 'paragraphs',
      index,
      config: { ...commonFieldConfig['ar'][commonFieldTypes.textarea] },
    }));

  return (
    <section className="mb-5">
      <h3 className="mb-3">Location Section</h3>
      <img
        src={generateImagePath('location-section.webp')}
        alt=""
        className="mb-3 w-100"
      />
      <div className="row">
        {/* English Location Fields */}
        <div className="col-md-6">
          {locationLinkFieldEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              config={field.config}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  isSameValue: field.isSameValue,
                })
              }
            />
          ))}
        </div>

        {/* Arabic Location Fields */}
        {/* <div className="col-md-6" dir="rtl">
          {locationLinkFieldAr.map((field, index) => (
            <TextInputField
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange(e, field.section, field.field, 'ar')
              }
            />
          ))}
        </div> */}
      </div>

      <h4 className="mt-4 mb-3">Location Paragraphs</h4>
      <div className="row">
        {/* English Paragraphs */}
        <div className="col-md-6">
          {locationparagraphsFieldsEn.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'en',
                  index: field.index,
                })
              }
              config={field.config}
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
          {/* <AddMoreButton
            handleAddItem={() => handleAddItem('locationSection', 'paragraphs')}
          /> */}
        </div>

        {/* Arabic Paragraphs */}
        <div className="col-md-6" dir="rtl">
          {locationparagraphsFieldsAr.map((field, index) => (
            <FieldTypeSelector
              key={index}
              label={field.label}
              fieldName={field.field}
              value={field.value}
              onInputChange={(e) =>
                handleInputChange({
                  e,
                  section: field.section,
                  field: field.field,
                  lang: 'ar',
                  index: field.index,
                })
              }
              config={field.config}
              removeFromList={() =>
                dispatch(
                  removeItemFromArray({
                    section: field.section,
                    field: field.field,
                    index,
                  }),
                )
              }
            />
          ))}
        </div>
        <AddMoreButton
          handleAddItem={() => handleAddItem('locationSection', 'paragraphs')}
        />
      </div>

      <h4 className="mt-4 mb-3">Nearby Locations</h4>
      <NearbyLocation
        handleNearbyLocations={handleNearbyLocations}
        nearbyLocationsAr={nearbyLocationsAr}
        nearbyLocationsEn={nearbyLocationsEn}
      />
    </section>
  );
}
